import { css, keyframes } from 'emotion';

const dance = keyframes`
  0% {
    transform: rotate(0deg) translate3d(0, 0, 0) rotate(0deg) ;
  }
  33.33% {
    transform: rotate(0deg) translate3d(22px, 0, 0) rotate(0deg) ;
  }
  66.66% {
    transform: rotate(0deg) translate3d(44px, 0, 0) rotate(0deg);
  }
  95% {
    transform: rotate(110deg) translate3d(0px, 0px, 0) rotate(-50deg);
  }
`;

export const loaderContainer = css`
  position: fixed;
  top: 64px;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const darkLoader = css`
  transform: translateX(-30px);
  &.small {
    transform: scale(0.7);
  }
  span {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    animation: ${dance} 3s infinite;
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .yellow {
    background: #decd27;
  }
  .blue {
    background: #1c62fd;
    animation-delay: -1s;
  }
  .green {
    background: #1bfda2;
    animation-delay: -2s;
  }
`;
